import { Button, Dialog, DialogActions, DialogContent, DialogContentText } from '@mui/material'
import React from 'react'

const ConfirmDialog = ({ open, handleCancel, handleAccept, message }) => {
    return (
        <Dialog
            open={open}
            onClose={handleCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth="xs"
            fullWidth
        >

            <DialogContent>
                <DialogContentText id="alert-dialog-description" >
                    {message || 'Are you sure you want to delete this component?'}
                </DialogContentText>
            </DialogContent>
            <DialogActions >
                <Button
                    onClick={handleCancel}
                    variant="outlined"
                    color="error"
                >
                    Cancel
                </Button>
                <Button
                    onClick={handleAccept}
                    variant="contained"
                    color="error"
                >
                    Ok
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ConfirmDialog